'use client';

import {
  faCircleInfo,
  faMessageQuestion,
  faPhoneAlt,
  faSeedling,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import CidLink from '@/components/marketing/cid-link';

// Define navigation items configuration
const navItems = [
  {
    href: '/#kontakt',
    text: 'Kontakt',
    icon: faPhoneAlt,
  },
  {
    href: '/#faq',
    text: 'FAQ',
    icon: faMessageQuestion,
  },
  {
    href: '/so-funktionierts',
    text: 'Mieter Informationen',
    icon: faCircleInfo,
  },
  {
    href: '/werte',
    text: 'Nachhaltigkeit',
    icon: faSeedling,
  },
];

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const openMobileMenu = () => setIsMobileMenuOpen(true);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <header>
      <div id="headerheight" className="fixed top-0 z-10 w-full">
        <div className="relative bg-white">
          <div className="mx-auto flex items-center justify-between px-4 py-6 sm:px-6 md:space-x-10 lg:px-8">
            <div className="hidden justify-start md:flex lg:w-0 lg:flex-1">
              <Link href="/">
                <span className="sr-only">aareal-aval.de</span>
                <Image
                  className="h-10 w-auto sm:h-12"
                  src="/assets/images/aareal-aval.png"
                  alt="Aareal Aval Logo"
                  width="2081"
                  height="507"
                />
              </Link>
            </div>
            {/* mobile burger menu */}
            <div className="-my-2 -mr-2 shrink-0 md:hidden">
              <button
                type="button"
                className="inline-flex items-center justify-center rounded-md bg-white p-2 text-primary hover:bg-gray-100 hover:text-neutral focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-inset"
                aria-expanded={isMobileMenuOpen}
                onClick={openMobileMenu}
              >
                <span className="sr-only">Menü öffnen</span>
                <svg
                  className="h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap={'round'}
                    strokeLinejoin={'round'}
                    strokeWidth={'2'}
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </button>
            </div>
            {/* mobile logo */}
            <div className="flex min-w-0 flex-1 justify-center px-2 md:hidden">
              <Link href="/">
                <Image
                  className="h-auto w-full max-w-[170px]"
                  src="/assets/images/aareal-aval.png"
                  alt="aval logo"
                  width="2081"
                  height="507"
                />
              </Link>
            </div>

            {/* Desktop Menu */}
            <nav className="hidden items-center space-x-10 md:flex">
              {navItems.map((item) => (
                <div key={item.href} className="relative">
                  <Link
                    href={item.href}
                    className={
                      'font-medium text-aareal-aval text-base hover:text-aareal-aval-light'
                    }
                    onClick={closeMobileMenu}
                  >
                    {item.text}
                  </Link>
                </div>
              ))}
              {/* Keep CidLink separate */}
              <div className="relative">
                <CidLink>Antrag vervollständigen</CidLink>
              </div>
            </nav>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-x-0 top-0 z-30 origin-top-right transform p-2 md:hidden">
          <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-aareal-aval ring-opacity-5">
            <div className="px-5 pt-5 pb-6">
              <div className="flex items-center justify-between">
                <div>
                  <Image
                    className="h-8 w-auto"
                    src="/assets/images/aareal-aval.png"
                    alt="aval logo"
                    width="1387"
                    height="338"
                  />
                </div>
                <div className="-mr-2">
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
                    onClick={closeMobileMenu}
                  >
                    <span className="sr-only">Close menu</span>
                    <svg
                      className="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap={'round'}
                        strokeLinejoin={'round'}
                        strokeWidth={'2'}
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="mt-6">
                <nav className="grid grid-cols-1 gap-7">
                  {navItems.map((item) => (
                    <Link
                      key={item.href}
                      href={item.href}
                      className={'-m-3 flex items-center rounded-lg p-3 hover:bg-gray-50'}
                      onClick={closeMobileMenu}
                    >
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-aareal-aval text-white">
                        <FontAwesomeIcon icon={item.icon} size="lg" />
                      </div>
                      <div className={'ml-4 font-medium text-base text-gray-700'}>{item.text}</div>
                    </Link>
                  ))}
                  {/* Keep CidLink separate */}
                  <CidLink className="w-full" onNavigate={closeMobileMenu}>
                    Antrag vervollständigen
                  </CidLink>
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
